export default () => {
	const checkbox = 'input[type="checkbox"]';
	const classBefore = 'before';
	const classAfter = 'after';

	// Switches
	const setCheckedClass = (wrapper) => {
		const classList = wrapper.classList;
		if (wrapper.querySelector(checkbox).checked) {
			if (classList.contains(classBefore)) classList.remove(classBefore);
			classList.add(classAfter);
		} else {
			if (classList.contains(classAfter)) classList.remove(classAfter);
			classList.add(classBefore);
		}
	};

	document.querySelectorAll('.custom-switch-wrapper').forEach((elem) => {
		setCheckedClass(elem);

		// Add listener
		elem.querySelector(checkbox).addEventListener('change', () => {
			setCheckedClass(elem);
		});
	});
};
